export interface SettingsIconProps {
  className?: string;
}

export function SettingsIcon({ className }: SettingsIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 10a2 2 0 100-4 2 2 0 000 4z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.933 10a1.1 1.1 0 00.22 1.213l.04.04a1.333 1.333 0 11-1.886 1.887l-.04-.04a1.1 1.1 0 00-1.214-.22 1.1 1.1 0 00-.666 1.007v.113a1.333 1.333 0 01-2.667 0v-.06a1.1 1.1 0 00-.72-1.006 1.1 1.1 0 00-1.213.22l-.04.04a1.333 1.333 0 11-1.887-1.887l.04-.04a1.1 1.1 0 00.22-1.213 1.1 1.1 0 00-1.007-.667h-.113a1.333 1.333 0 110-2.666h.06a1.1 1.1 0 001.006-.72 1.1 1.1 0 00-.22-1.214l-.04-.04a1.333 1.333 0 111.887-1.886l.04.04a1.1 1.1 0 001.213.22h.053a1.1 1.1 0 00.667-1.007v-.113a1.333 1.333 0 012.666 0v.06a1.1 1.1 0 00.667 1.006 1.1 1.1 0 001.213-.22l.04-.04a1.333 1.333 0 111.887 1.887l-.04.04a1.1 1.1 0 00-.22 1.213v.053a1.1 1.1 0 001.006.667h.114a1.333 1.333 0 010 2.666h-.06a1.1 1.1 0 00-1.007.667z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

